import React from "react";
import "./FeatureHighlights.css";

const FEATURES = [
    "Trim",
    "Merge",
    "Convert",
    "Cloud Sync",
    "AI Transcript",
    "AI Summary",
    "Text to Speech",
    "Extract Audio",
    "Translate",
    "Adjust Audio",
    "Notes",
];

const FeatureHighlights = ({ onSelect }) => {
    return (
        <div className="feature-highlights">
            <p className="feature-highlights__title">Also Includes</p>
            <div className="feature-highlights__viewport">
                <div className="feature-highlights__track">
                    {/* the list is rendered twice so the loop restarts without a visible seam */}
                    {[0, 1].map((copy) => (
                        <ul className="feature-highlights__list" key={copy} aria-hidden={copy === 1}>
                            {FEATURES.map((feature) => (
                                <li
                                    key={feature}
                                    className="feature-highlights__chip"
                                    onClick={() => onSelect && onSelect(feature)}
                                >
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeatureHighlights;
